<template>
    <div>
        <Portlet class="right-panel" :fullHeight="true" :noPadding="true">
            <template slot="Title">
                {{ Translations.sections.planning.source.title }}
            </template>
            <template slot="Options">
                <!---->
            </template>
            <template slot="Content">
                <WaitingBlock v-if="isLoadingStationDayTemplates"></WaitingBlock>
                <div v-else id="planning-source">
                    <ItemMenuList :isLoading="isLoadingStationDayTemplates">
                        <template slot="Content">
                            <b-list-group v-if="stationDayTemplates != null">
                                <MenuCard v-for="dt in stationDayTemplates" :key="dt.uid" :menuItem="dt" :href="''" :disableLink="true" :isDraggable="dt.isValid" :itemType="'dayTemplate'" :class="!dt.isValid ? 'no-drag' : ''">
                                    <template slot="Decorator">
                                        <i :class="['fas', dt.isValid ? 'fa-check' : 'fa-minus']" :style="{ color: dt.colorCode }"></i>
                                    </template>
                                    <template slot="Badge">
                                        <span></span>
                                    </template>
                                </MenuCard>
                            </b-list-group>
                            <div v-else>No day template available</div>
                        </template>
                        <template slot="Actions">
                        </template>
                    </ItemMenuList>
                </div>
              <router-link  :to="{name:'WeekTemplatesHome'}">
              <div style="position:absolute; bottom: 10px;  margin:10px 10px 10px 30px;">
                  <button style=" text-align: center;">Automation Week Template</button>
              </div>
              </router-link>
            </template>
        </Portlet>

    </div>

</template>
<script>
    import Vue from 'vue'
    import Translations from '@/store/translations';
    import router from '@/router';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue'
    import WaitingBlock from '@/components/common/WaitingBlock.vue'
    import ItemMenuList from '@/components/common/ItemMenuList.vue'
    import MenuCard from'@/components/common/MenuCard'
    import Constants from "@/store/constants";
    import { mapState } from 'vuex';
    import VueCookie from 'vue-cookie';
    // Tell Vue to use the plugin
    Vue.use(VueCookie);

    export default {
        name: "PlanningSourcePanel",
        components: { Portlet, WaitingBlock, ItemMenuList, MenuCard },
        computed: {
            Translations: () => Translations,
            ...mapState({
                isLoadingStationDayTemplates: state => state.loadingStates.isLoadingStationDayTemplates,
                stationDayTemplates: state => {
                    if (state.stationDayTemplates == null) return [];
                    return state.stationDayTemplates.items;
                },
            }),
        },
        data() {
            var defaultConfig = {
                MUSIC: true,
                JINGLE: true,
                VOICE_TRACK: true,
            };
            var allowedBoxTypes = [Constants.boxTypes.BOX, Constants.boxTypes.SMARTBOX,];
            var allowedTrackTypes = [Constants.trackTypes.MUSIC, Constants.trackTypes.JINGLE, Constants.trackTypes.VOICE_TRACK];
            var configCookie = null;
            try {
                configCookie = JSON.parse(this.$cookie.get('clockSourceConfig') || null) || defaultConfig;
            } catch (e) {
                configCookie = defaultConfig;
            }
            return {
                expandedSections: configCookie, allowedBoxTypes, allowedTrackTypes
            }
        },
        methods: {
            toggleSection(sectionKey) {
                this.expandedSections[sectionKey] = !this.expandedSections[sectionKey];
                this.$cookie.set('clockSourceConfig', JSON.stringify(this.expandedSections));
            }
        }
    }
</script>
<style scoped>
    .m-content .right-panel {
        width: 250px;
        margin-left: 10px;
    }

    .decorator {
        margin-right: 10px;
    }

    .no-drag {
        background-color: rgba(0,0,0, .05);
        cursor: not-allowed;
        color: hsl(0, 0%, 43%);
    }
</style>
